import { render, staticRenderFns } from "./_orders.tab.vue?vue&type=template&id=4c885cb0&scoped=true&"
import script from "./_orders.tab.vue?vue&type=script&lang=js&"
export * from "./_orders.tab.vue?vue&type=script&lang=js&"
import style0 from "./_orders.tab.vue?vue&type=style&index=0&id=4c885cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c885cb0",
  null
  
)

export default component.exports